import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SeoService } from '@out-web/core';

@Component({
  selector: 'out-all-locations',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  templateUrl: './all-locations.component.html',
  styleUrl: './all-locations.component.scss',
})
export class AllLocationsComponent implements OnInit {
  activeTab: 'buy' | 'sell' = 'buy';
  searchQuery = '';
  states = [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ];

  get filteredStates(): string[] {
    if (!this.searchQuery) return this.states;

    return this.states.filter((state) =>
      state.toLowerCase().includes(this.searchQuery.toLowerCase())
    );
  }

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.setMetaData();
  }

  setActiveTab(tab: 'buy' | 'sell') {
    this.activeTab = tab;
  }

  private setMetaData() {
    const title = 'Locations | Only Used Tesla Marketplace';
    const description = '#1 marketplace dedicated to selling a used Tesla. Discover. Buy. Sell. A Used Tesla Marketplace.';
    const imageUrl = 'https://onlyusedtesla.com/assets/images/meta-logo.png';
    const url = 'https://onlyusedtesla.com/locations';

    this.seoService.setMetaData(title, description, imageUrl, url);
  }
}
